import { ConfigApi, IdentityApi } from '@backstage/core-plugin-api';
import { PatternApi, PatternMetrics, ReportInfo } from './pattern-api';

export class PatternClient implements PatternApi {
  private readonly configApi: ConfigApi;
  private readonly identityApi: IdentityApi;

  constructor(options: { identityApi: IdentityApi; configApi: ConfigApi }) {
    this.identityApi = options.identityApi;
    this.configApi = options.configApi;
  }

  /**
   *  Get the pattern adoption metrics results data
   * @param organization - The organization name
   * @param repo - The repository nam
   * @param organization - The organization name
   * @param repo - The repository nam
   * @returns PatternMetrics
   */
  private async getPatternMetricsResultsData(
    patternVersionField: string,
    organization: string,
    repo: string,
  ): Promise<PatternMetrics> {
    try {
      const { token } = await this.identityApi.getCredentials();

      const backendHost = this.configApi.getString('backend.baseUrl');

      const endpoint = `${backendHost}/api/pattern/adoption?patternVersionField=${encodeURIComponent(
        patternVersionField,
      )}&organization=${encodeURIComponent(
        organization,
      )}&repo=${encodeURIComponent(repo)}`;
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json',
        },
      });

      const data: any = await response.json();
      return {
        adoptionDetails: data.adoptionDetails as ReportInfo[],
        currentVersion: data.currentVersion as string,
        chartData: data.chartData as PatternAdoptionChartData[],
      };
    } catch (error: any) {
      throw error;
    }
  }

  getPatternMetricsResults(
    patternVersionField: string,
    organization: string,
    repo: string,
  ): Promise<PatternMetrics> {
    return this.getPatternMetricsResultsData(
      patternVersionField,
      organization,
      repo,
    );
  }
}
